/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};

(function () {
  'use strict';
  
  /**
   * Bид элемента паджинации.
   */
  app.GetParamPaginationView = app.BasePaginationView.extend({
    /**
     * Меняет страницу
     * @private
     */
    _change: function () {
      var value = this.$('.js-select-page-input').val();
      if (value) {
        location.assign(app.helpers.UrlHelper.to(location.pathname, ['sort', 'per-page', 'mode', 'currency'], {page: value}));
      }
    }
  });
})();

}.call(window));